import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ProductService } from 'src/app/services/api/product/product.service';
import { OrderSummary } from 'src/app/services/api/orders/orders.service';
import { Product } from 'src/app/models/interface/product/product';
import { TraceabilityDetailComponent } from '../traceability-detail/traceability-detail.component';


const isProduct = (item: any): item is Product => {
  return 'productState' in item;
}

const isSummary = (item: any): item is OrderSummary => {
  return 'externalId' in item;
}

@Component({
  selector: 'app-traceability-list',
  templateUrl: './traceability-list.component.html',
  styleUrls: ['./traceability-list.component.css']
})
export class TraceabilityListComponent implements OnInit, OnChanges {

  @Input() item: Product | OrderSummary;
  @Input() params: any;
  @Input() displayedColumns: string[] = [];;
  @Input() title: string;

  @ViewChild(MatSort, { static: false }) sort: MatSort;

  dataSource: MatTableDataSource<any> = new MatTableDataSource([]);

  appData: any;
  type: string;
  serviceInfo: any;

  constructor(
    private productService: ProductService,
    public dialog: MatDialog
  ) { }

   ngOnInit(): void {
     this.loadTraces();
   }

   ngOnChanges(changes: SimpleChanges): void {
       if (changes.item) {
             this.loadTraces();
       }
   }

   openModal(element: any) {
     this.productService.getTraceability(element).subscribe((data) => {
       this.dialog.open(TraceabilityDetailComponent, {
         data: {
           title: 'Información de la comunicación',
           json: data
         },
         width: '850px'
       });
     });
   }

  private loadTraces(): void {
    let externalId = '';
    if (isProduct(this.item)) {
      this.type = !this.params.type ? 'product' : this.params.type;
      if (this.type === 'rfs') {
        for (const cfs of this.item.cfses) {
          if (cfs.rfses.find(service => service.id === +this.params.map)) {
            this.serviceInfo = cfs.rfses.find(service => service.id === +this.params.map);
            break;
          }
        }
        externalId = this.serviceInfo.name;
      } else {
        externalId = this.item.name;
      }
    } else if (isSummary(this.item)) {
      externalId = this.item.serviceRef;
    }
    this.productService.getTraceabilities(externalId).subscribe((data) => {
      this.dataSource.data = data.content;
    });
  }
}
